function setCookie(key: string, value: string) {
    const dStr = new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toUTCString()
    const c = `${key}=${value}; expires=${dStr}`;
    document.cookie = c;
}
export function initPCode() {
    var s = location.search || ""
    if (s.length < 5) s = location.hash || "";
    const idx = s.indexOf("?");
    if (idx == -1) return;
    var ps = new URLSearchParams(s.substring(idx + 1))
    ps.forEach((v, k) => {
        switch (k.toLowerCase()) {
            case "pcode":
            case "promocodesetid":
                break;
            default: return;
        }
        console.error("QS", v, k)
        setCookie(k, v);
    });
}